// src/pages/Contact.js
import ContactHero from "../components/Contact/ContactHero";
import Footer from "../components/Footer";

function Contact() {

    return (
        <>
            <main>
                <ContactHero />
            </main>
            <section>
                <Footer />
            </section>
        </>
    );
  }
  
  export default Contact;